import { render } from "./LdapTestConnectionModal.vue?vue&type=template&id=02059404&scoped=true"
import script from "./LdapTestConnectionModal.vue?vue&type=script&lang=js"
export * from "./LdapTestConnectionModal.vue?vue&type=script&lang=js"

import "./LdapTestConnectionModal.vue?vue&type=style&index=0&id=02059404&lang=scss&scoped=true"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02059404"]])

export default __exports__